const cloneDeep = require("lodash/cloneDeep");
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      widthModal: '92%',
      heightModal: 'auto',
      gallery: [],
      isPreviewDataLoading: true,
      selectedImage: null,
      selectedCategory: "",
      selectedImageId: "",
      showCTAButton: false,
      maxWidth: 800,
      views: [
        'image-gallery',
        'image-gallery-continue-and-edit-view'
      ],
      editComponents: []
    };
  },
  computed: {
    // TODO is main app
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    ugcSize() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_size;
    },
    returnPlacementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    getMultipart() {
      return this.$store.getters["ugc/tempData/checkMultipart"];
    },
    // TODO deprecate this and this.selectedImage(Id)
    selectedSwatchUrl() {
      if (!this.selectedImage) return '';
      return this.selectedImage?.ugc_swatch?.image_url;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    selectedSwatches() {
      return this.$store.state.swatches.selectedSwatches;
    },
    tempData() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex];
    },
    selectedImages() {
      return this.$store.state.imageGallery.selectedImages;
    },
    currentImages() {
      return this.$store.state.imageGallery.currentImages;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    activeViewIndex() {
      return this.$store.state.imageGallery.navigation.activeViewIndex;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    nextUGCComponent() {
      return this.$store.getters["ugc/getNextUGCComponent"];
    },
    storeMultipleUGCsizes() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].storeMultipleUGCsizes;
    },
    // TODO change for reposition flow 1st view storeMultipleUGCsizes
    isBackButtonVisible() {
      const { navigation } = this.$store.state.imageGallery;
      return navigation.activeViewIndex > 0;
    },
    // TODO change to use stateManagers or a new value in imageGallery store
    hasFinishedApplying() {
      return this.tempData.hasFinishedApplying;
    },
    showLibrarySpinner() {
      return !this.hasFinishedApplying || this.isPreviewDataLoading || !this.gallery;
    },
  },
  methods: {
    /**
     * Tracking Datalayer Events
     */
    trackData({eventAction = 'imageLibrary', eventLabel = '', eventType = ''}) {
      if (!this.useEcomDataLayerFormat) {
      } else {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: eventAction,
          eventLabel: eventLabel,
        });
      }
    },

    /**
     * Returns all values used during flow to default when user finishes or exits imageLibrary
     */
    clearData() {
      // this.gallery = null;
      this.selectedImageId = "";
      this.editComponents = [];
      this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.$store.state.standardNavigation.activeComponent);
      this.$store.commit("ugc/stateManager/CLEAR");
      this.$store.commit("ugc/tempData/CLEAR");
      this.$store.commit("ugc/placements/CLEAR_ALL");
      this.$store.commit("ugc/stateManager/RESTART_STATE_MANAGER");
      this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", null);
      this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", false);
      this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", false);
      this.$store.commit("imageGallery/CLEAR_SELECTED_IMAGES");
      this.$store.commit("imageGallery/RESET_NAVIGATION");
      this.$store.commit("imageGallery/SET_IS_BACK_APPLIED", false);
      this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", 0);
      this.$store.commit("imageGallery/SET_USE_SAME_IMAGE", true);
      // this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", false);
      this.isPreviewDataLoading = true;
    },

    /**
     * Sets the navigation for imageGallery with the ugcFlowViews in tempData from UGC
     */
    initializeNavigation() {
      this.views = [
        'image-gallery',
        'image-gallery-continue-and-edit-view'
      ];
      this.$store.commit("imageGallery/RESET_NAVIGATION");
      const { ugcFlowViews } = this.tempData;
      this.views.push(...ugcFlowViews);
      this.$store.commit("ugc/SET_UGC_VIEWS");
      this.$store.commit('imageGallery/SET_VIEWS', this.views);
      this.$store.commit("imageGallery/SET_ACTIVE_VIEW", this.views[0]);
    },

    /**
     * Resets the stateManagers per component when the UGC modal is re-opened
     * @param {*} componentName the component to set in stateManagers again
     */
    resetStateManager(componentName) {
      const { tempData } = this.$store.state.ugc;
      const stateManager = tempData.features[tempData.activeUGCIndex].stateManagers[
        componentName
      ];
      this.$store.commit("ugc/stateManager/SET_STATE_MANAGER", stateManager);
    },

    /**
     *
     */
    goBackAction() {
      const isSecondComponent = this.isSecondaryComponentFlow();

      // Back button on 2nd component image-gallery view from replace/select another flows
      if (isSecondComponent) {
        this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", this.$store.state.imageGallery.currentUgcView - 1);
        this.resetActiveUgcImage(this.selectedImages?.[this.activeComponent].original_image);
        this.$store.commit("imageGallery/CLEAR_COMPONENT_SELECTED_IMAGE", {componentName: this.tempData.activeUGCComponent});
        this.$store.commit("imageGallery/SET_IS_BACK_APPLIED", true);
        // Remove the 2nd added image-gallery when navigating back
        if ( this.views.filter(view => view === 'image-gallery' ).length > 1 ) {
          this.views.splice(this.views.lastIndexOf('image-gallery'), 1);
        }
        this.resetStateManager(this.activeComponent);
        this.$modal.hide('addYourImageGallery');
        this.$modal.show(this.configuration.enableNewUgcModal ? "newUgcModal" : "ugcModal");
        this.$store.commit("ugc/stateManager/SET_CURRENT_UGC_VIEW", this.$store.state.imageGallery.currentUgcView);
        this.$store.commit("ugc/SET_CURRENT_FEATURE_UGC_VIEW", 'ugc-almost-done');
        this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", null);
        this.$store.commit("ugc/tempData/IS_REPLACE_TOOL", false);
        this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", false);
        this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.activeComponent);
        // TODO reset image_category from current component selected category for it to be correct if using continue same image
        this.selectedCategory = this.selectedImages?.[this.activeComponent]?.category;
        if (!!this.selectedCategory) this.$store.commit("imageGallery/SET_IMAGE_CATEGORY", this.selectedCategory);
      }

      this.$store.commit("imageGallery/PREV_VIEW");
      document.querySelector(`.new-modal-button-nav-container-cta`).classList.remove("hide");
      this.$ugcDataLayer.logAnalyticsEvent({
        action: 'imageLibrary',
        type: this.$ugcDataLayer.types.backModal
      });
    },

    /**
     *
     */
    goToNextStep() {
      this.$store.commit("imageGallery/NEXT_VIEW");
    },

    /**
     *
     */
    isSecondaryComponentFlow() {
      const { tempData } = this.$store.state.ugc;
      const { activeComponent } = this.$store.state.standardNavigation;
      const { activeUGCComponent } = tempData.features[tempData.activeUGCIndex];
      const secondaryComponent = this.$store.getters["ugc/getUGCComponentNotActive"];
      const isSecondaryComponentFlow = this.$store.getters["imageGallery/isSecondComponentFlow"];

      if (activeComponent !== activeUGCComponent ||
        secondaryComponent === activeUGCComponent ||
        isSecondaryComponentFlow
      ) {
        return true;
      }
      return false;
    },

    /**
     * @function checkLibraryEntryPoint
     * Checks for URL params to determine if coming from external entrypoint
     * If imageLibrary is true, it will open the modal by default on load
     * TODO: Set the active image_category from recipe to be expanded by default
     */
    checkLibraryEntryPoint() {
      const { imageLibrary, categories } = this.$store.state.utils.queryParams;
      if (!imageLibrary) return;
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
      if (!!categories) this.categories = categories.split(',');
      // Set isUGCLoadingFromEntrypoint on 1st time opening from entryPoint to keep sizeSelection enabled in 2nd step
      this.$store.commit("ugc/LOADING_UGC_FROM_ENTRYPOINT", 1);
      this.$modal.show('addYourImageGallery', {categories: this.categories});
    },

    /**
     * TODO do we need this here
     */
    clearStoredData() {
      this.$store.commit("ugc/tempData/CHANGE_UGC_ACTIVE_COMPONENT");
      this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
      this.$store.commit("ugc/stateManager/CLEAR");
      // removes the saved buffer because it has higher priority than the uploaded image URL
      this.$store.commit("ugc/placements/CLEAR_COMPONENT_BUFFER", this.nextUGCComponent);
      // removes the cropper state in case the user has used the cropper tool and returned to upload a new image
      this.$store.commit("ugc/tempData/SAVE_CROPPER_STATE", { componentName: this.nextUGCComponent });
      // TODO save component placements in tempData in case user goes back
      // this.$store.state.ugc.placements.responses[this.componentName]
      this.$store.commit("ugc/placements/CLEAR_PLACEMENTS");
      this.$store.commit(
        "ugc/tempData/SAVE_STATE_MANAGERS",
        this.$store.state.ugc.stateManager
      );
    },

    /**
     * @function replaceImageLibraryTool
     * Replace image ugc tool from ReplaceImageControls in Edit flow ugcModal Design view
     * If used on 2nd component edit flow replicates the selectAnother flow
     */
    replaceImageLibraryTool() {
      const { tempData } = this.$store.state.ugc;
      if (tempData.activeUGCIndex !== 1) return;
      const ugcEnabledComponents = this.$store.getters["ugc/getUGCEnabledComponents"];
      const isReplaceTool = this.$store.state.ugc.stateManager.activeControl === "ugc-replace-image-control";
      const isSecondComponent = this.isSecondaryComponentFlow();
      this.$store.commit("ugc/tempData/IS_REPLACE_TOOL", isReplaceTool);
      this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", isSecondComponent);

      if (ugcEnabledComponents.length > 1 && isSecondComponent) {
        if (!this.tempData.selectAnother) {
          // if not active select another, this means its coming from continue same image flow then replace tool
          this.$store.commit("imageGallery/PREV_VIEW");
        }
        this.imageLibrarySelectAnother();
      } else {
        this.$store.commit("imageGallery/SET_ACTIVE_VIEW", this.views[0]);
        this.$store.commit("ugc/tempData/SET_CONTINUE_EDIT_FLOW", false);
        this.$modal.show('addYourImageGallery');
      }
    },

    /**
     * @function imageLibrarySelectAnother
     * Select Another Image flow from the edit flow in almost done view in ugcModal
     * Or when replace tool is used on 2nd component
     */
    imageLibrarySelectAnother() {
      this.$store.commit("imageGallery/SET_USE_SAME_IMAGE", false);
      this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", true);
      this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", true);

      const secondaryComponent = this.$store.getters["ugc/getUGCComponentNotActive"];
      this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', secondaryComponent);
      const { tempData } = this.$store.state.ugc;
      const { selectedImages } = this.$store.state.imageGallery;
      const { activeUGCComponent } = tempData.features[tempData.activeUGCIndex];
      if (!selectedImages?.[activeUGCComponent]) {
        this.resetActiveUgcImage();
      }
      this.addNextComponentViews();
      this.gallery = [];
      this.$modal.show('addYourImageGallery');
    },

    /**
     * Adds the 2nd image-gallery view to the navigation views array for 2nd component edit flow
     */
    addNextComponentViews() {
      const selectView = 'image-gallery';
      let { views, activeViewIndex } = this.$store.state.imageGallery.navigation;
      let viewIndex = activeViewIndex + 1;
      if ( views.filter(val => val === selectView ).length == 1 ) {
        views.splice(viewIndex, 0, selectView);
        this.$store.commit("imageGallery/SET_VIEWS", views);
        this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", true);
      }
      this.views = views;
      this.$store.commit("imageGallery/SET_ACTIVE_VIEW", selectView);
    },

    /**
     * When the user is starting reposition flow from BuyPanel
     * initialize the navigation for imageLibrary so user can use replace tool
     */
    startRepositionFlowLibrary() {
      this.$store.dispatch("ugc/CREATE_UGC_FLOW_VIEWS");

      const { recipe: tempRecipe, activeUGCComponent, activeUGCView } = this.tempData;
      const componentImage = tempRecipe?.components?.[activeUGCComponent]?.ugc?.original_image;
      this.initializeNavigation();
      this.$store.commit("imageGallery/SET_ACTIVE_VIEW", activeUGCView);
      // this.setComponentSelectedImage(activeUGCComponent);

      // TODO check if component is UGC, and get the ugc image from the other tempData?
      this.resetActiveUgcImage(componentImage);
    },

    /**
     * Size Selection is in the 2nd step (continue to customizer), we need to regenerate the selected image on save
     * to ensure we're using the correct image URLs & 3D model sizes
     */
    async reloadGallerySizes() {
      const { tempData } = this.$store.state.ugc;
      const image_id = tempData.features[1].ugc_image_id;
      const ugcSize = tempData.features[1].ugc_size;
      if (ugcSize) {
        this.$store.commit("ugc/tempData/SET_TEMP_BUCKET_SIZE", this.$store.state.utils.bucketSizes[ugcSize]);
        this.$store.commit("ugc/tempData/SET_BUCKET_SIZE", tempData.features[1].tempBucketSize);
      }
      await this.loadImages({});
      await this.$store.dispatch("ugc/SAVE_ASSETS_3D");
      // todo fix the structure of gallery to allow filter in an more elegent form...
      const category = this.$store.state.imageGallery.image_category;
      const img = this.gallery.filter(cat => cat.key === category)[0][category]
        .filter(image => image.ugc.original_image.image_id === image_id)[0];
      img.category = category;
      await this.onSelectImage(img);
      this.saveImgPlacements();
    },

    /**
     * @param {object} originalImage - ugc.original_image object for selected image
     */
    resetActiveUgcImage(originalImage = null) {
      if (!originalImage || !originalImage.hasOwnProperty('image_id') || !originalImage.hasOwnProperty('image_url')) {
        this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {});
        this.$store.commit("imageGallery/SET_IMAGE_CATEGORY", "");
        this.selectedImageId = "";
        return;
      }
      const { image_id, image_url } = originalImage;
      const fileFormat = image_url.split(".").pop();
      this.selectedImageId = image_id;

      this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
        imagePath: image_url,
        temp_image_id: image_id,
        imageFormat: fileFormat
      });
    },

    /**
     * Sets the category and ugc image from tempRecipe component
     * Ensure the component has been saved to tempRecipe before calling
     */
    setComponentUgcImage() {
      const { features, activeUGCIndex } = this.$store.state.ugc.tempData;
      const { recipe, activeUGCComponent } = features[activeUGCIndex];
      let { ugc: ugcObject, toolkit_options: toolkitObj } = recipe.components[activeUGCComponent];
      this.selectedCategory = toolkitObj?.image_library_category;
      this.$store.commit("imageGallery/SET_IMAGE_CATEGORY", this.selectedCategory);
      const { image_id, image_url } = ugcObject.original_image;
      const fileFormat = image_url.split(".").pop();

      this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
        imagePath: image_url,
        temp_image_id: image_id,
        imageFormat: fileFormat
      });
    },

    /**
     * TODO reset active category
     * This one may not be needed anymore, the idea is to run this on load of the modal to get the correct place
     * from where the correct images are loaded into each component (storageController/currentImages, tempData/selectedImages, or none)
     */
    setComponentSelectedImage(activeComponent) {
      const { isBackToLibraryApplied } = this.$store.state.imageGallery;
      const { recipe: tempRecipe, activeUGCComponent, selectAnother, isReplaceTool, applyUGCComponents } = this.tempData;
      const isSecondComponentFlow = this.isSecondaryComponentFlow();
      const component = isSecondComponentFlow ? activeUGCComponent : activeComponent;

      let recipeComponent = this.$store.getters["imageGallery/getStorageRecipeComponent"]({ activeComponent: component });
      let selectedImage = (isReplaceTool || isBackToLibraryApplied) ? this.selectedImages?.[component] : recipeComponent.ugc;

      // Set the selected image from the storageController recipe if set
      if (!!recipeComponent && (!this.selectedImages || !this.selectedImage)) {
        this.selectedImage = recipeComponent.ugc;
        this.selectedCategory = recipeComponent?.toolkit_options?.image_library_category;
        this.$store.commit("imageGallery/SET_SELECTED_IMAGE", {
          componentName: component,
          category: recipeComponent?.toolkit_options?.image_library_category,
          ugcObject: recipeComponent.ugc
        });
      }

      this.resetActiveUgcImage(selectedImage?.original_image);
    },

    setInitialData() {
      // this.gallery = null;
      this.isPreviewDataLoading = true;
      const { isBackToLibraryApplied } = this.$store.state.imageGallery;
      const { tempData } = this.$store.state.ugc;
      const { activeComponent } = this.$store.state.standardNavigation;
      if (!tempData.features[tempData.activeUGCIndex].selectAnother && !isBackToLibraryApplied) {
        this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', activeComponent);
      }
      const {
        recipe: tempRecipe,
        activeUGCComponent: componentName
      } = tempData.features[tempData.activeUGCIndex];
      // Set initial recipe from recipe_v2
      if (
        !tempData.features[tempData.activeUGCIndex].ugc_size ||
        !tempRecipe ||
        !tempRecipe.components
      ) {
        this.$store.commit("ugc/tempData/SET_RECIPE", this.$store.state.recipe.recipe_v2);
      }

      this.setComponentSelectedImage(activeComponent);

      let ugcSize = tempData.features[tempData.activeUGCIndex].ugc_size;
      const { ugc: ugcObject } = tempData.features[tempData.activeUGCIndex].recipe?.components?.[componentName];
      ugcSize = (!!ugcObject && ugcObject.size) ? ugcObject.size : ugcSize;
      if (!ugcSize) ugcSize = this.$ugc.getActiveUgcSize();

      this.$store.commit("ugc/tempData/SET_UGC_SIZE", ugcSize);
      this.$store.commit("ugc/tempData/SET_UGC_FEATURE", "library");
      if (!this.tempData.selectAnother && !this.tempData.isReplaceTool && !isBackToLibraryApplied) {
        this.$store.dispatch("ugc/CREATE_UGC_FLOW_VIEWS");
        this.initializeNavigation();
      }
      this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
      if (!!this.selectedImageId) {
        this.showCTAButton = true;
      }
    },

    /**
     * Loads the library images from action, params are optional and will use defaults if not passed
     * @param {Array} category keywords to load
     *
     * @returns
     */
    loadImages({ categories = [], ugcSize, componentName }) {
      return new Promise((resolve, reject) => {
        const { tempData } = this.$store.state.ugc;
        const { activeUGCIndex, features } = tempData;
        const { bucketSizes } = this.$store.state.utils;
        const size = !!ugcSize ? ugcSize : bucketSizes[features[activeUGCIndex].ugc_size];
        const component = componentName ?? '';

        this.$store.dispatch(
          'imageGallery/GET_CATEGORIES',
          { categories, size, component }
        ).then(gallery => {
          this.gallery = gallery;
          resolve(gallery);
        }).catch(err => {
          reject(err);
        });
      });
    },

    /**
     * @param {object} img the entire image object from the gallery
     */
    onSelectImage(img) {
      this.selectedImage = img.ugc;
      this.selectedCategory = img.category;

      this.resetActiveUgcImage(img.ugc.original_image);
      this.$store.commit("imageGallery/SET_SELECTED_IMAGE", {
        componentName: this.tempData.activeUGCComponent,
        category: this.selectedCategory,
        ugcObject: this.selectedImage
      });

      this.showCTAButton = true;
      this.$ugcDataLayer.logAnalyticsEvent({
        action: 'imageLibrary',
        type: this.$ugcDataLayer.types.selectImage,
        eventLabel: this.selectedCategory,
        image: img.ugc.original_image.image_id
      });
      this.$nextTick(() => {
        document.querySelector(`.new-modal-button-nav-container-cta`)?.focus();
      })
    },

    /**
     * Image Selection first view/step in the internal flow
     * TODO category reset is replace tool for 2nd
     */
    onNextImageSelection() {
      if (this.activeViewIndex >= this.views.length || this.isPreviewDataLoading) return;
      this.isPreviewDataLoading = true;
      const { tempData } = this.$store.state.ugc;
      const { isReplaceTool, selectAnother, activeUGCComponent } = tempData.features[tempData.activeUGCIndex];
      const isSecondComponent = this.isSecondaryComponentFlow();
      const { isBackToLibraryApplied } = this.$store.state.imageGallery;

      if (!isReplaceTool && !selectAnother) {
        this.$store.commit("ugc/tempData/SET_APPLY_UGC_COMPONENTS", activeUGCComponent);
      }
      if (!!this.selectedCategory) this.$store.commit("imageGallery/SET_IMAGE_CATEGORY", this.selectedCategory);
      // If the user is on selectAnother flow or reposition flow, we should go back to UgcModal after image selection
      if (selectAnother || isSecondComponent || this.storeMultipleUGCsizes) {
        this.$store.commit("ugc/placements/CLEAR_COMPONENT_BUFFER", activeUGCComponent);
        this.$store.commit("ugc/placements/CLEAR_PLACEMENTS");
        this.$store.commit("ugc/SET_CURRENT_FEATURE_UGC_VIEW", 'ugc-design-view');
        this.$store.dispatch("ugc/SAVE_ASSETS_3D").then(() => {
          this.$store.commit("ugc/SET_UGC_VIEWS");
          this.$modal.hide('addYourImageGallery');
          this.$modal.show(this.$store.state.utils.configuration.enableNewUgcModal ? "newUgcModal" : "ugcModal");
          const { currentUgcView } = this.$store.state.imageGallery;
          this.$store.commit("ugc/stateManager/SET_CURRENT_UGC_VIEW", currentUgcView);
          this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", false);
          this.goToNextStep();
          this.isPreviewDataLoading = false;
          this.$store.commit("imageGallery/SET_IS_BACK_APPLIED", false);
        });
      } else {
        this.goToNextStep();
        this.isPreviewDataLoading = false;
      }
      this.$ugcDataLayer.logAnalyticsEvent({
        action: 'imageLibrary',
        type: this.$ugcDataLayer.types.libraryNext,
        eventLabel: this.selectedCategory,
        image: this.selectedImage.original_image.image_id
      });
    },

    /**
     * Continue with same image
     * Prepares the flow in case user clicks the replace tool on 2nd component after using continue with same image
     */
    applySecondComponent() {
      this.$store.commit("imageGallery/SET_USE_SAME_IMAGE", true);
      const currentUgcView = this.$store.state.ugc.stateManager.currentUgcView;
      this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", currentUgcView);
      this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", true);
      this.goToNextStep();
    },

    /**
     * @function saveComponentEditFlow
     * Saves component to tempData recipe when applied from edit flow in ugcModal
     */
    saveComponentEditFlow() {
      if (this.$store.state.ugc.tempData.activeUGCIndex !== 1) return;
      const { tempData } = this.$store.state.ugc;
      const { activeUGCComponent, ugcFlowViews, recipe, ugc_image_id: ugcImageId, selectAnother, applyUGCComponents } = this.tempData;
      const isSecondComponent = this.isSecondaryComponentFlow();
      let imageCategory = this.selectedImages?.[activeUGCComponent]?.category ?? this.$store.state.imageGallery.image_category;
      // Reposition flow for authentic classic needs to maintain the selected image category per component
      imageCategory = this.storeMultipleUGCsizes ? this.currentImages?.[activeUGCComponent]?.category : imageCategory;

      // Fix to keep correct data per component feature on reposition flow with mixed features ugc and imageLibrary
      if (this.storeMultipleUGCsizes && !this.$recipe.checkForImageLibraryComponent(activeUGCComponent)) {
        return;
      }

      const toolKitObject = {
        image_library_id: ugcImageId,
        image_library_category: imageCategory
      }
      const data = recipe.components[activeUGCComponent];
      data.toolkit_options = toolKitObject;

      this.$store.commit("ugc/tempData/UPDATE_COMPONENT", { componentName: activeUGCComponent, data });
      if (!this.editComponents.includes(activeUGCComponent) && applyUGCComponents.includes(activeUGCComponent)) {
        this.editComponents.push(activeUGCComponent)
      }
      this.$store.commit("imageGallery/SET_SELECTED_IMAGE", {
        componentName: activeUGCComponent,
        category: imageCategory,
        ugcObject: data.ugc
      });

      this.$store.commit("ugc/tempData/IS_REPLACE_TOOL", false);

      if (selectAnother || isSecondComponent) {
        this.$store.commit(
          "ugc/stateManager/SET_CURRENT_UGC_VIEW",
          ugcFlowViews.length - 1
        );
        this.$store.commit("ugc/CHANGE_UGC_VIEW", true);
        this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", null);
        this.goToNextStep();
      } else {
        this.goToNextStep();
      }
    },

    /**
     * @function finishLibraryEditFlow
     * Finish CTA on Confirm Design step
     *
     */
    finishLibraryEditFlow() {
      if (this.$store.state.ugc.tempData.activeUGCIndex !== 1) return;
      let saveComponents = [];
      const { tempData } = this.$store.state.ugc;
      const activeIndex = tempData.features[1];
      const { applyUGCComponents } = activeIndex;
      const storageRecipe = this.$store.state.imageGallery.storageController.recipe;
      this.$store.commit("ugc/tempData/SET_CONTINUE_EDIT_FLOW", false);

      this.editComponents.forEach(component => {
        const data = this.tempData.recipe.components[component];
        const feature = this.$recipe.getUGCFeatureType(component);
        // only update components that are actually imageLibrary in case the user gets to confirmDesign then goes back and only saves 1st component
        if (!applyUGCComponents.includes(component) || !data.hasOwnProperty("ugc")) {
          if (storageRecipe) {
            // Resets 2nd component tempData to be stored in storageController
            this.$store.commit("ugc/tempData/UPDATE_COMPONENT", {
              componentName: component,
              data: this.$store.state.recipe.recipe_v2.components[component]
            });
          }
          return;
        }

        this.$store.commit("recipe/UPDATE_COMPONENT", { componentName: component, data });
        this.$store.commit("imageGallery/SET_COMPONENT_CURRENT_IMAGE", {
          componentName: component,
          category: data.toolkit_options.image_library_category,
          ugcObject: data.ugc
        });
        saveComponents.push({ component, feature, isSameFeature: feature === 'imageLibrary' });
      });

      this.$eventBus.$emit("savePreviousSwatch", {
        saveComponents
      });
      // Update storageController after undo
      this.$store.commit("imageGallery/SET_LIBRARY_RECIPE", activeIndex.recipe);
      // Reset isUGCLoadingFromEntrypoint after user saves custom new recipe
      this.$store.commit("ugc/LOADING_UGC_FROM_ENTRYPOINT", null);
    },

    /**
     * TODO GLOBAL15-54257 handle use cases for 2nd component go back flow
     */
    async saveImgPlacements() {
      if (this.getMultipart > 1 && this.selectedImage?.placements?.length) {
        for (let placement of this.selectedImage.placements) {
          if (this.multipart === this.returnPlacementViewOrder) break;
          this.$store.commit("ugc/placements/SAVE_PLACEMENT_IMAGE", {
            imageData: placement,
            canvasJSON: null
          });
          this.$store.commit("ugc/tempData/UPDATE_PLACEMENT_VIEW_ORDER", true);
        }
      } else if (this.selectedImage?.placements?.length) {
        this.$store.commit("ugc/placements/SAVE_PLACEMENT_IMAGE", {
          imageData: this.selectedImage.placements[0],
          canvasJSON: null
        });
      } else {
        // TODO: Remove fallback when endpoint is finished
        this.$store.commit("ugc/placements/SAVE_PLACEMENT_IMAGE", {
          imageData: this.selectedImage.original_image,
          canvasJSON: null
        });
      }

      await this.$store.dispatch("ugc/SAVE_UGC_SWATCH", this.selectedImage.ugc_swatch);
      this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
      this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", true);
      // Reset isUGCLoadingFromEntrypoint after user saves custom new recipe
      this.$store.commit("ugc/LOADING_UGC_FROM_ENTRYPOINT", null);
    },

    setBucketSize() {
      const { tempData } = this.$store.state.ugc;
      const ugcSize = tempData.features[1].ugc_size;
      if (ugcSize) {
        this.$store.commit("ugc/tempData/SET_TEMP_BUCKET_SIZE", this.$store.state.utils.bucketSizes[ugcSize]);
      }
    },

    /**
     * Open the flow from the edit and reposition modal in UGC
     * Set initial data, initialize everything including the tempData and imageGallery store (navigation)
     *
     */
    editPlacementsImageLibrary() {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
      this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.activeComponent);
      this.$store.commit("ugc/tempData/SET_CONTINUE_EDIT_FLOW", true);
      this.setInitialData();

      this.goToNextStep();
      this.$store.dispatch("ugc/SAVE_ASSETS_3D")
        .then(() => {
          this.$store.commit("ugc/SET_UGC_VIEWS");
          this.$modal.show(
            this.$store.state.utils.configuration.enableNewUgcModal
              ? "newUgcModal"
              : "ugcModal"
          );
          this.goToNextStep();
        });
    },

    /**
     * Add the selected image to tempData if the recipe_v2 component was replaced
     * TODO toolkit_options category GLOBAL15-54257
     */
    editImageLibrary() {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
      this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.activeComponent);

      const { activeUGCComponent: componentName, recipe: tempRecipe } = this.tempData;
      const feature = this.$recipe.getUGCFeatureType(componentName);
      const storageComponent = this.$store.getters["imageGallery/getStorageRecipeComponent"]({ activeComponent: componentName })
        || this.recipe_v2.components[componentName];

      if (storageComponent) {
        this.$store.commit("ugc/tempData/SET_RECIPE", this.$store.state.recipe.recipe_v2);

        if (!feature || feature !== 'imageLibrary')
          this.$store.commit("ugc/tempData/UPDATE_COMPONENT", { componentName, data: storageComponent });

      } else {
        console.warn(`Unable to get ugc object for ${componentName}`);
        return;
      }

      let { ugc: ugcObject, toolkit_options: toolkitObj } = storageComponent;
      this.$store.commit("ugc/tempData/SET_UGC_SIZE", ugcObject.size);
      this.resetActiveUgcImage(ugcObject.originalImage);
      this.selectedCategory = toolkitObj?.image_library_category;
      this.$store.commit("imageGallery/SET_IMAGE_CATEGORY", this.selectedCategory);
      this.$store.commit("imageGallery/SET_SELECTED_IMAGE", {
        componentName,
        category: this.selectedCategory,
        ugcObject
      });

      this.$store.dispatch("ugc/SAVE_ASSETS_3D")
        .then(() => {
          this.$store.commit("ugc/SET_UGC_VIEWS");
          this.$modal.show('addYourImageGallery');

        });
    },

    reApplyImageLibrary({imgLibData = null}){
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
      this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.activeComponent);
      this.$store.commit("utils/SET_TRAY_DISABLED_STATUS", { element: "swatches", status: true });
      this.$store.commit("utils/SET_TRAY_DISABLED_STATUS", { element: "geostates", status: true });
      const { tempData } = this.$store.state.ugc;
      const { activeUGCComponent } = tempData.features[1];
      this.$eventBus.$emit("savePreviousSwatch", {feature: this.$recipe.getUGCFeatureType(activeUGCComponent)});
      const data = imgLibData ?? this.$store.state.imageGallery.storageController.recipe?.components?.[activeUGCComponent];
      this.$store.commit("ugc/tempData/SET_RECIPE", this.$store.state.recipe.recipe_v2);
      this.$store.commit('swatches/SET_SWATCHES_SELECTED', {
        component: this.activeComponent,
        data: { ...this.selectedSwatches[this.activeComponent], default: false },
      });
      this.$store.commit("ugc/tempData/UPDATE_COMPONENT", { componentName: activeUGCComponent, data });
      this.$store.commit("recipe/UPDATE_COMPONENT", { componentName: activeUGCComponent, data });
      this.$store.commit("imageGallery/UPDATE_LIBRARY_COMPONENT", {componentName: activeUGCComponent, data});
      this.$store.commit("imageGallery/SET_COMPONENT_CURRENT_IMAGE", {
        componentName: activeUGCComponent,
        category: data.toolkit_options.image_library_category,
        ugcObject: data.ugc
      });
      this.setComponentUgcImage();
      this.createAllUGCTextures().then(() => {
        return this.$store.dispatch('swatches/GET_RELATION_SWATCH_BY_FEATURE_ID', 'image_library');
      })
      .then(({ swatches_not_allowed }) => {
        this.$store.commit(
          'swatches/SET_DISABLED_SWATCHES_BY_FEATURE',
          { swatches: swatches_not_allowed, feature: 'imageLibrary' },
        );
        this.$store.commit("utils/SET_TRAY_DISABLED_STATUS", { element: "swatches", status: false });
        this.$store.commit("utils/SET_TRAY_DISABLED_STATUS", { element: "geostates", status: false });
        this.$store.commit("ugc/tempData/CLEAR");
      });
    }
  },
  created () {
    this.$eventBus.$on("reApplyImageLibrary", this.reApplyImageLibrary);
  },
  beforeDestroy () {
    this.$eventBus.$off("reApplyImageLibrary", this.reApplyImageLibrary);
  },
});
